module.exports = __webpack_public_path__ + "img/instructions_1@2x.41b99484.png";